import { AttachmentFilter, sexesAreCompatible } from "@animech/supermodel";
import { AttacherSolverContext } from "./attacher-solver-context";
import { AttributeBond, FamilyType } from "./attacher-attribute";

type CustomAttachmentFilter = (
	args: Parameters<AttachmentFilter>[0] & {
		context: Readonly<AttacherSolverContext>;
	},
) => ReturnType<AttachmentFilter>;

const check = {
	namesAreCompatible: (args) => args.from.node.name === args.to.node.name,
	sexesAreCompatible: (args) =>
		sexesAreCompatible(args.from.node.sex, args.to.node.sex),
} as const satisfies Record<string, CustomAttachmentFilter>;

const defaultAttachmentFilter: CustomAttachmentFilter = (args) =>
	check.namesAreCompatible(args) && check.sexesAreCompatible(args);

const attachmentFilterByFamilyBond: AttributeBond<
	FamilyType,
	CustomAttachmentFilter
> = {} as const;

export function createAttachmentFilter(
	context: AttacherSolverContext,
): AttachmentFilter {
	const { attacherAttributeMap } = context;

	return (args) => {
		const fromFamily = attacherAttributeMap.get("family", args.from);
		const toFamily = attacherAttributeMap.get("family", args.to);

		return (
			attachmentFilterByFamilyBond[fromFamily]?.[toFamily] ??
			defaultAttachmentFilter
		)({ ...args, context });
	};
}
